import React from 'react';
import { Link } from 'react-router-dom';
import { RxCross2 } from 'react-icons/rx';
import { Minus, Plus } from 'lucide-react';
import { FaArrowLeft, FaCaretRight } from 'react-icons/fa';
import { TbPercentage } from 'react-icons/tb';
import Namsteji_Manikchand_Icon from '../../../../../assets/images/Namsteji_Manikchand_Icon.svg';
import config from '../../../../../config/environment';
import CouponPage from '../../Cart/Components/CouponPage';
const SERVER_URL = config.SERVER_URL;
const ProductAddToCartMobilePage: React.FC<any> = ({
  cartDataArr,
  isCartOpen,
  cartItemPlusMinus,
  setIsCartOpen,
  cartItems,
  couponObj,
}) => {
  return (
    <>
      {/* Mobile veiw md& sm */}
      <div className='block sm:block md:block lg:hidden'>
        <div
          className={`fixed top-0 right-0 h-full bg-slate-50 shadow-lg z-50 transform transition-transform duration-300 flex flex-col
                    ${isCartOpen ? 'translate-x-0' : 'translate-x-full'} w-full`}
        >
          <div className='flex-1 overflow-y-auto py-3 px-6 flex flex-col gap-2'>
            <div>
              <div className='flex flex-row items-center p-1 gap-1'>
                <button onClick={() => setIsCartOpen(false)} className='flex flex-row items-center text-xl gap-2'>
                  <FaArrowLeft className='w-[18px] h-[20px]' />
                  <span className='font-semibold font-rubik text-[18px]'>Cart</span>
                </button>
              </div>

              <div className='flex justify-between place-items-end pt-2 '>
                <h2 className='text-base font-semibold text-[#0a0908] font-poppins'>Item Added</h2>
                <Link to='/products'>
                  <button className='text-sm text-[#442a10] border-b border-[#442a10] font-poppins'>Add More</button>
                </Link>
              </div>
            </div>

            <div className='bg-white rounded-xl shadow-md p-3 space-y-3'>
              {cartItems.map((item: any, index: any) => {
                const isDisabled = !item.tax_amount || item.tax_amount <= 0;

                return (
                  <div
                    key={`${item.item_code}-${index}`}
                    className={`flex items-center gap-3 p-3 rounded-lg border-b border-gray-200 
                                            ${isDisabled ? 'opacity-80 pointer-events-none' : ''}`}
                  >
                    <img
                      src={
                        item.web_item_name?.thumbnail
                          ? SERVER_URL + item.web_item_name?.thumbnail
                          : Namsteji_Manikchand_Icon
                      }
                      alt=''
                      className='w-[60px] h-[60px] md:w-[120px] md:h-[120px] object-cover rounded'
                    />
                    <div className='flex flex-col flex-1'>
                      <h3 className='text-sm sm:text-base md:text-lg text-[#1A1A1A] font-poppins'>
                        {item.web_item_name?.web_item_name}
                      </h3>
                      <p className='text-base sm:text-lg md:text-xl text-orange-900 flex items-center font-poppins'>
                        {item.qty} <RxCross2 className='w-4 h-4' /> {item?.rate}
                        <span className='text-xs sm:text-sm md:text-base pl-1 text-[#9E9E9E] font-poppins'>
                          {item.uom_conversion?.conversion_factor
                            ? 'Pack of ' + item.uom_conversion.conversion_factor
                            : ''}
                        </span>
                      </p>
                    </div>
                    <div className='flex flex-col items-center'>
                      {/* Plus-Minus Control */}
                      <div
                        className={`flex items-center gap-2 border border-[#C12E2A] rounded-lg px-2 py-1
                                                ${isDisabled ? 'pointer-events-none opacity-80 cursor-not-allowed' : ''}`}
                      >
                        <button onClick={() => cartItemPlusMinus(item.qty, item.item_code, 'minus')}>
                          <Minus className='text-red-700' size={16} />
                        </button>
                        <span className='font-medium'>{item.qty}</span>
                        <button onClick={() => cartItemPlusMinus(item.qty, item.item_code, 'plus')}>
                          <Plus className='text-red-700' size={16} />
                        </button>
                      </div>

                      {/* Price */}
                      <div className='mt-1 text-right'>
                        <p className='font-semibold text-black font-poppins'>
                          ₹{item.tax_amount ? item.tax_amount.toFixed(2) : '0.00'}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {couponObj.listOfCoupen.current && couponObj.listOfCoupen.current.length > 0 && (
              <div
                className='flex items-center justify-center gap-2 py-3 rounded-xl shadow-md border mt-3 cursor-pointer bg-white'
                onClick={() => couponObj.setShowCoupenModalMobile(true)}
              >
                <div className='w-6 h-6 flex items-center justify-center rounded-full bg-[#552B18]'>
                  <TbPercentage className='w-4 h-4 text-white' />
                </div>
                <span className='font-medium font-poppins'>See all offers</span>
                <FaCaretRight className='w-4 h-4 text-[#552B18] ' />
              </div>
            )}
            <div className='p-4 bg-white rounded-lg shadow-md gap-2 mt-3'>
              <h2 className='text-lg font-semibold mb-4 font-poppins'>Cart Total</h2>
              <div className='text-sm sm:text-sm md:text-base text-[#9E9E9E]'>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>Subtotal</span>
                  <span className='font-poppins'>₹ {cartDataArr?.net_total?.toFixed(2)}</span>
                </div>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>
                    Discount{' '}
                    {cartDataArr?.additional_discount_percentage
                      ? '(' + cartDataArr?.additional_discount_percentage + ') % OFF'
                      : ''}
                  </span>
                  <span className='font-poppins'>
                    ₹ {cartDataArr?.discount_amount ? cartDataArr.discount_amount.toFixed(2) : '0.00'}
                  </span>
                </div>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>Effective subtotal</span>
                  <span className='font-poppins'>
                    ₹ {cartDataArr?.discount_amount ? cartDataArr.discount_amount.toFixed(2) : '0.00'}
                  </span>
                </div>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>GST</span>
                  <span className='font-poppins'>₹ {cartDataArr?.tax_amount?.toFixed(2)}</span>
                </div>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>Shipping</span>
                  <span className='text-green-600 font-poppins'>Free</span>
                </div>
                <hr className='my-2 border-gray-300' />
                <div className='flex justify-between text-base font-semibold mb-4 font-poppins text-black'>
                  <span className='font-poppins'>Grand Total</span>
                  <span className='font-poppins'>
                    ₹ {cartDataArr?.grand_total ? cartDataArr?.grand_total?.toFixed(2) : '0.00'}
                  </span>
                </div>
              </div>
              <Link to='/product/billing-info'>
                <button className='text-white text-lg font-semibold py-2 px-4 rounded-md w-full bg-[#C12E2A] hover:bg-[#a02823ff] font-poppins'>
                  Proceed to Checkout
                </button>
              </Link>
            </div>
          </div>
        </div>

        {couponObj.showCoupenModalMobile && (
          <div tabIndex={-1} className='fixed top-0 left-0 right-0 z-50 w-full overflow-x- overflow-y-auto '>
            <div className='relative bg-white rounded-lg shadow-sm dark:bg-gray-700 min-h-[100vh]'>
              <div className='flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200'>
                <div></div>
                <div className='text-xl font-bold font-rubik text-[#552B18]'>Coupon Code</div>
                <button
                  type='button'
                  className='bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg'
                  onClick={() => couponObj.setShowCoupenModalMobile(false)}
                >
                  <RxCross2 className='text-xl text-[#552B18]' />
                </button>
              </div>
              <CouponPage
                inputCode={couponObj.inputCode}
                handleApply={couponObj.handleApply}
                listOfCoupen={couponObj.listOfCoupen}
                appliedCouponName={couponObj.appliedCouponName.current}
                handleRemoveCoupon={couponObj.handleRemoveCoupon}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductAddToCartMobilePage;
